export default __webpack_public_path__ + "static/media/new-jazz-logo.8f5865d7.svg";